(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
      document.documentElement.classList.add('safari-browser');
    }
    // -------------------------------
    // ⏱ Countdown Timers (optimized)
    // -------------------------------
    const timers = Array.from(document.querySelectorAll('.gs-steal-badge-timmer'));
    if (timers.length) {
      const parsedTimers = timers.map((el) => {
        const parseTime = (raw) => {
          if (!raw) return null;
          if (/^\d+$/.test(raw)) {
            const n = Number(raw);
            return n > 1e12 ? Math.floor(n / 1000) : n; // handle ms vs sec
          }
          const ms = Date.parse(raw);
          return isNaN(ms) ? null : Math.floor(ms / 1000);
        };
        const startTs = parseTime(el.dataset.time_start);
        const endTs = parseTime(el.dataset.time_end);
        return { el, startTs, endTs };
      });

      function formatHHMMSS(sec) {
        sec = Math.max(0, Math.floor(sec));
        const h = Math.floor(sec / 3600);
        const m = Math.floor((sec % 3600) / 60);
        const s = sec % 60;
        return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
      }

      // Single global update loop
      const updateAll = () => {
        const now = Math.floor(Date.now() / 1000);
        parsedTimers.forEach((t) => {
          const { el, startTs, endTs } = t;
          if (!endTs) return (el.textContent = '00:00:00');

          if (startTs && now < startTs) {
            el.textContent = 'Not started';
            return;
          }

          const remaining = endTs - now;
          if (remaining <= 0) {
            el.textContent = '00:00:00';
            return;
          }

          el.textContent = formatHHMMSS(remaining);
        });
      };

      updateAll();
      setInterval(updateAll, 1000);
    }
    
  });

    // Function to initialize lazy fade images
  function initLazyFadeImages(context = document) {
    const lazyImages = context.querySelectorAll('.lazy-fade-image');

    lazyImages.forEach(wrapper => {
      const realImg = wrapper.querySelector('.real-img');
      const placeholder = wrapper.querySelector('.placeholder-img');

      if (!realImg || realImg.classList.contains('loaded')) return;

      // Load the real image
      const tempImg = new Image();
      tempImg.src = realImg.src;
      tempImg.onload = () => {
        realImg.classList.add('loaded');
        placeholder.classList.add('fade-out');
      };
    });
  }

// Replace with your actual section ID
const sectionWrapper = document.querySelector('.main-collection-section-wrapper');
const sectionId = sectionWrapper.getAttribute('data-section_id');
const sectionSelector = '#shopify-section-' + sectionId;
const sectionNode = document.querySelector(sectionSelector);

if (sectionNode) {
  const observer = new MutationObserver((mutationsList, observer) => {
    // This code runs every time the section is updated via AJAX
    // Place your custom JS here
    // For example, re-initialize sliders, event listeners, etc.
    initLazyFadeImages();
  });
  observer.observe(sectionNode, { childList: true, subtree: true });
}


  } catch(e) { console.error(e); }
})();
})();
